var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mt-1" }, [
      _c("label", [_vm._v("Выбрать производителя")]),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            _c("Search", {
              ref: "searchM",
              attrs: {
                customPreset: { placeholder: "Поиск производителя" },
                searchType: "manufacturer",
                onSelect: (m) => _vm.addNewManufacturer(m),
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-default",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.addNewManufacturer()
              },
            },
          },
          [_vm._v("Создать нового")]
        ),
      ]),
      _vm._v(" "),
      _vm.selectedManufacturer?.id || _vm.createNewManufacturer
        ? _c(
            "div",
            [
              _c("EditManufacturer", {
                attrs: {
                  onSelectManufacturer: (m) => _vm.addNewManufacturer(m),
                  savedManufacturer: _vm.selectedManufacturer,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", { attrs: { for: "" } }, [_vm._v("Выберите препарат")]),
        _vm._v(" "),
        _c("Search", {
          ref: "search",
          attrs: {
            customPreset: { placeholder: "Поиск препарата" },
            searchType: "003_drugs",
            onSelect: (record) => _vm.addDrug(record),
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("div", { staticClass: "flex justify-content-between mb-1" }, [
            _c("span", [_vm._v("Комментарии")]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-default", on: { click: _vm.addComment } },
              [_vm._v("добавить комментарий")]
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.reportComments, function (c, i) {
            return _c("div", { staticClass: "input-group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: c.text,
                    expression: "c.text",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: c.text },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(c, "text", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group-append" },
                [
                  _c("DateSelectProps", {
                    attrs: {
                      disabled: true,
                      onSelect: (date) => (c.date = date),
                    },
                  }),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-2 text-right" },
      [
        _c("LoadingButton", {
          attrs: {
            title: "Сохранить",
            loading: _vm.loading,
            color: _vm.$constants.SUCCESS_COLOR,
            onClick: () => _vm.saveTask(),
            className: "btn btn-outline-success",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }